'use es6';

import * as ActionTypes from './ActionTypes';
import * as ecosystemClient from '../clients/ecosystemClient';
import * as qualityClient from '../clients/qualityClient';
import I18n from 'I18n';
const notificationsKey = 'appMarketplace.detail.reviews';
export const getReviews = queries => dispatch => {
  dispatch({
    type: ActionTypes.REVIEWS_FETCH_REQUESTED
  });
  return ecosystemClient.fetchReviews(queries).then(resp => {
    dispatch({
      type: ActionTypes.REVIEWS_FETCH_RECEIVED,
      payload: resp
    });
  }).catch(err => {
    dispatch({
      type: ActionTypes.REVIEWS_FETCH_FAILED,
      payload: err
    });
  });
};
export const getAllReviews = offeringId => dispatch => {
  let reviewsOffset = 0;
  let totalReviewsList = [];
  dispatch({
    type: ActionTypes.REVIEWS_FETCH_REQUESTED
  });

  const recursivelyGetAllReviews = () => ecosystemClient.fetchReviews({
    entityId: offeringId,
    offset: reviewsOffset
  }).then(resp => {
    const {
      total,
      reviews
    } = resp;
    totalReviewsList = totalReviewsList.concat(reviews);

    if (totalReviewsList.length < total) {
      reviewsOffset = reviewsOffset + 10;
      return recursivelyGetAllReviews();
    } else {
      return dispatch({
        type: ActionTypes.REVIEWS_FETCH_RECEIVED,
        payload: {
          reviews: totalReviewsList,
          total: resp.total
        }
      });
    }
  }).catch(err => {
    dispatch({
      type: ActionTypes.REVIEWS_FETCH_FAILED,
      payload: err
    });
  });

  return recursivelyGetAllReviews(offeringId);
};
export const resetReviewsFetch = () => ({
  type: ActionTypes.REVIEWS_FETCH_RESET
});
export const getReviewsStats = offeringId => dispatch => {
  dispatch({
    type: ActionTypes.REVIEWS_STATS_REQUESTED
  });
  return ecosystemClient.fetchReviewsStats(offeringId).then(resp => {
    dispatch({
      type: ActionTypes.REVIEWS_STATS_RECEIVED,
      payload: resp
    });
  }).catch(err => {
    dispatch({
      type: ActionTypes.REVIEWS_STATS_FAILED,
      payload: err
    });
  });
};
export const resetReviewsStatsFetch = () => ({
  type: ActionTypes.REVIEWS_STATS_RESET
});
export const submitReview = (review, slug) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_WRITE_REQUESTED
  });
  dispatch({
    type: ActionTypes.NEW_REVIEW_SUBMITTED,
    payload: review,
    meta: {
      slug
    }
  });
  return ecosystemClient.writeReview(review).then(resp => {
    dispatch({
      type: ActionTypes.REVIEW_WRITE_RECEIVED,
      payload: resp
    });
    return resp;
  }).catch(err => {
    dispatch({
      type: ActionTypes.REVIEW_WRITE_FAILED
    });
    throw err;
  });
};
export const resetReviewSubmitted = () => ({
  type: ActionTypes.REVIEW_SUBMITTED_RESET
});
export const setReviewHelpful = (reviewId, userId, isHelpful) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_HELPFUL_REQUESTED
  });
  return ecosystemClient.toggleReviewHelpful(reviewId, isHelpful).then(() => {
    dispatch({
      type: ActionTypes.REVIEW_HELPFUL_RECEIVED,
      payload: {
        reviewId,
        userId,
        isHelpful
      }
    });
  }).catch(err => {
    dispatch({
      type: ActionTypes.REVIEW_HELPFUL_FAILED,
      payload: err,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.helpful.error.titleText`),
          message: I18n.text(`${notificationsKey}.helpful.error.message`)
        }
      }
    });
  });
};
export const reportReview = ({
  reviewId,
  reportReason,
  comment
}) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_REPORT_REQUESTED
  });
  return qualityClient.reportReview({
    reviewId,
    reportReason,
    comment
  }).then(resp => {
    dispatch({
      type: ActionTypes.REVIEW_REPORT_RECEIVED,
      payload: resp,
      meta: {
        notification: {
          titleText: I18n.text(`${notificationsKey}.reportModal.success.titleText`),
          message: I18n.text(`${notificationsKey}.reportModal.success.message`)
        }
      }
    });
  }).catch(err => {
    const alreadyReported = err.responseJSON && err.responseJSON.message && err.responseJSON.message.includes('already reported');
    const errorKey = alreadyReported ? 'duplicate_error' : 'error';
    dispatch({
      type: ActionTypes.REVIEW_REPORT_FAILED,
      payload: err,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.reportModal.${errorKey}.titleText`),
          message: I18n.text(`${notificationsKey}.reportModal.${errorKey}.message`)
        }
      }
    });
  });
};
export const reportReply = ({
  reviewId,
  replyId,
  reportReason,
  comment
}) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_REPORT_REPLY_REQUESTED
  });
  return qualityClient.reportReply({
    reviewId,
    replyId,
    reportReason,
    comment
  }).then(resp => {
    dispatch({
      type: ActionTypes.REVIEW_REPORT_REPLY_RECEIVED,
      payload: resp,
      meta: {
        notification: {
          titleText: I18n.text(`${notificationsKey}.reportModal.success.titleText`),
          message: I18n.text(`${notificationsKey}.reportModal.success.message`)
        }
      }
    });
  }).catch(err => {
    const alreadyReported = err.responseJSON && err.responseJSON.message && err.responseJSON.message.includes('already reported');
    const errorKey = alreadyReported ? 'duplicate_error' : 'error';
    dispatch({
      type: ActionTypes.REVIEW_REPORT_REPLY_FAILED,
      payload: err,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.reportModal.${errorKey}.titleText`),
          message: I18n.text(`${notificationsKey}.reportModal.${errorKey}.message`)
        }
      }
    });
  });
};
export const updateReviewFilters = (updates, trackInteraction) => ({
  type: ActionTypes.REVIEW_FILTERS_UPDATED,
  payload: updates,
  meta: {
    trackInteraction
  }
});
export const updateReviewability = slug => ({
  type: ActionTypes.NEW_REVIEW_SUBMITTED_SUCCESS,
  meta: {
    slug
  }
});